import disclaimerSlice from './disclaimer';
import footnotesSlice from './footnotes';
import headerSlice from './header';
import proofCategorySlice from './proof-category';

const PRISMIC_TO_PARSER_SLICE = {
  header: headerSlice,
  proof_category: proofCategorySlice,
  disclaimer: disclaimerSlice,
  footnotes: footnotesSlice,
};

export default PRISMIC_TO_PARSER_SLICE;
